const AVATAR_GRADIENTS = [
  'linear-gradient(135deg, #1B4332, #2D5A3D)',
  'linear-gradient(135deg, #2A4494, #1E3270)',
  'linear-gradient(135deg, #F59E0B, #D97706)',
  'linear-gradient(135deg, #7C3AED, #5B21B6)',
  'linear-gradient(135deg, #DC2626, #B91C1C)',
  'linear-gradient(135deg, #0891B2, #0E7490)',
  'linear-gradient(135deg, #059669, #047857)',
  'linear-gradient(135deg, #DB2777, #BE185D)',
];

export const getAvatarGradient = (name: string): string => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return AVATAR_GRADIENTS[hash % AVATAR_GRADIENTS.length];
};

export const getInitials = (name: string): string =>
  name.split(' ').map(n => n[0] ?? '').join('').slice(0, 2).toUpperCase();
